/** @format */

import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
// import { MdOutlineArrowForwardIos } from "react-icons/md";
import RenewalCard from "./RenewalCard";
import { fetchAllIncentivesData } from "../../../redux/reducers/apiSlice";
import moment from "moment";
import PayoutsTable from "../../components-bootstrap/PayoutsTable";
import { BodyBuilder } from "../../../exports/Images";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import IncentiveHistory from "../incentive-penalty/IncentiveHistory";
import { selectAuth } from "../../auth/auth.selector";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import { convertThenFormat } from "../../common-data/Converts";

const Incentives = ({ selectedGyms, daysFilter }) => {
  const dispatch = useDispatch();
  const tableIncRef = useRef(null);
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const isAdmin = decryptedText?.account_type === "admin";
  const { loading, allIncentivesData } = useSelector((state) => state.api);
  const [selectedFilter, setSelectedFilter] = useState({});
  const initialIncentiveData = {
    allIncentivesData: [],
    incentivesStatsData: [],
    incentivesTableData: [],
  };
  const [allIncentive, setAllIncentive] = useState(initialIncentiveData);
  const [searchString, setSearchString] = useState("");
  const [imageModal, setImageModal] = useState(false);
  const [viewImage, setViewImage] = useState("");
  const initialIncentiveHistoryData = {
    incentiveHistoryModal: false,
    incentiveHistoryData: [],
    tabName: "",
  };
  const [incentiveHistory, setIncentiveHistory] = useState(
    initialIncentiveHistoryData
  );

  const startOfMonth = moment()
    .tz("Asia/Kolkata")
    .startOf("month")
    .format("YYYY-MM-DD");
  const endOfMonth = moment()
    .tz("Asia/Kolkata")
    .endOf("month")
    .format("YYYY-MM-DD");
  const selectedGymQueryParam =
    isAdmin && selectedFilter?.value
      ? `&gym_id=${selectedFilter?.value}`
      : isAdmin && selectedGyms?.value
      ? `&gym_id=${selectedGyms.value}`
      : !isAdmin
      ? `&user_id=${decryptedText?.user_id || decryptedText?.uid}`
      : "";
  const startDateQueryParam = !daysFilter
    ? `&start_date=${startOfMonth}&end_date=${endOfMonth}`
    : daysFilter?.startDate && daysFilter?.endDate
    ? `&start_date=${daysFilter.startDate}&end_date=${daysFilter.endDate}`
    : daysFilter?.startDate
    ? `&start_date=${daysFilter.startDate}`
    : daysFilter?.endDate
    ? `&end_date=${daysFilter.endDate}`
    : "";
  const searchQueryParam = searchString ? `&search=${searchString}` : "";
  const queryParametersFor = `${selectedGymQueryParam}${startDateQueryParam}`;

  let incentives = {};
  allIncentive.incentivesStatsData?.forEach((gymData) => {
    incentives[gymData.gym_id] = gymData;
  });

  const onClickSearch = () => {
    dispatch(
      fetchAllIncentivesData({
        queryParameters: queryParametersFor,
        searchString: searchQueryParam,
        token: decryptedText?.token,
      })
    );
  };

  const handleCardClick = () => {
    if (selectedFilter?.label === selectedGyms?.label) {
      setSelectedFilter(null);
    } else {
      setSelectedFilter(selectedGyms);
      tableIncRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    dispatch(
      fetchAllIncentivesData({
        queryParameters: queryParametersFor,
        token: decryptedText?.token,
      })
    );
  }, [queryParametersFor]);

  useEffect(() => {
    if (allIncentivesData?.status && allIncentivesData?.data?.length > 0) {
      setAllIncentive((prev) => ({
        ...prev,
        incentivesStatsData: allIncentivesData?.data,
      }));
      // setAllIncentive({
      //   ...allIncentive,
      //   incentivesStatsData: allIncentivesData?.data,
      // });
    } else {
      setAllIncentive((prev) => ({
        ...prev,
        incentivesStatsData: [],
      }));
      // setAllIncentive({
      //   ...allIncentive,
      //   incentivesStatsData: [],
      // });
    }

    if (allIncentivesData?.status && allIncentivesData?.staff?.length > 0) {
      setAllIncentive((prevs) => ({
        ...prevs,
        incentivesTableData: allIncentivesData?.staff,
      }));
      // setAllIncentive({
      //   ...allIncentive,
      //   incentivesTableData: allIncentivesData?.staff,
      // });
    } else {
      setAllIncentive((prevs) => ({ ...prevs, incentivesTableData: [] }));
      // setAllIncentive({
      //   ...allIncentive,
      //   incentivesTableData: [],
      // });
    }
  }, [allIncentivesData]);

  useEffect(() => {
    if (searchString?.length === 0) {
      dispatch(
        fetchAllIncentivesData({
          queryParameters: queryParametersFor,
          token: decryptedText?.token,
        })
      );
    }
  }, [searchString]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  const allIncentivesTableColumns = [
    {
      dataField: "name",
      text: "Trainer",
      formatter: (cell, row, rowIndex) => (
        <div className="emeberDetailsRowContainer">
          <img
            src={row?.profile || BodyBuilder}
            alt={row?.name || "N/A"}
            className="image"
            onClick={() => {
              setViewImage(row?.profile || BodyBuilder);
              setImageModal(true);
            }}
          />
          <p className="name textMedium minWidth150">
            {row?.name || "N/A"} (
            {row?.account_type === "receptionist"
              ? "Sales Executive"
              : row?.account_type}
            )
          </p>
        </div>
      ),
    },
    {
      dataField: "mobile",
      text: "Mobile",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer">
          <p className="name center textMedium">{row?.mobile || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer">
          <p className="name center textMedium" style={{ width: "150px" }}>
            {row?.gym_name || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "base_salary",
      text: "Base Salary",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer">
          <p className="name center textBig font-weight-bold">
            ₹
            {row?.base_salary
              ? convertThenFormat(parseFloat(row.base_salary).toFixed(2) || 0)
              : "0.00"}
          </p>
        </div>
      ),
    },
    {
      dataField: "earnings",
      text: "Rewards",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer">
          <p
            className="name center textBig font-weight-bold"
            style={{ color: "#38A000" }}
            onClick={() => {
              setIncentiveHistory({
                ...incentiveHistory,
                tabName: "rewards",
                incentiveHistoryModal: true,
                incentiveHistoryData: row,
              });
            }}
          >
            + ₹
            {row?.earnings?.totalEarning
              ? parseFloat(row.earnings.totalEarning).toFixed(2)
              : "0"}
          </p>
        </div>
      ),
    },
    {
      dataField: "renewals",
      text: "Renewals",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer">
          <p
            className="name center textBig font-weight-bold"
            style={{ color: "#38A000" }}
            onClick={() => {
              setIncentiveHistory({
                ...incentiveHistory,
                tabName: "renewals",
                incentiveHistoryModal: true,
                incentiveHistoryData: row,
              });
            }}
          >
            + ₹
            {row?.earnings_renewals?.totalEarning
              ? parseFloat(row.earnings_renewals.totalEarning).toFixed(2)
              : "0"}
          </p>
        </div>
      ),
    },
    {
      dataField: "penalty",
      text: "Penalty",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer">
          <p
            className="name center textBig font-weight-bold"
            style={{ color: "#F13434" }}
          >
            - ₹{row?.penalty ? parseFloat(row.penalty).toFixed(2) : "0"}
          </p>
        </div>
      ),
    },
    {
      dataField: "totalSalary",
      text: "Total",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer">
          <p className="name center textBig font-weight-bold">
            ₹
            {row?.totalSalary ? parseFloat(row.totalSalary).toFixed(2) : "0.00"}
          </p>
        </div>
      ),
    },
  ];

  return (
    <div className="columsDivsContainer">
      <Modal
        isOpen={imageModal}
        onRequestClose={() => setImageModal(false)}
        contentLabel="Discussion Brief Modal"
        ariaHideApp={false}
      >
        <div
          className="createNewCTOModalContainer discussionModalBriefContainer"
          style={{
            width: "auto",
            height: "auto",
          }}
        >
          <ModalHeadAndClose title=" " onClose={() => setImageModal(false)} />
          <div className="discussionModalMessage">
            <img
              src={viewImage}
              alt="profile"
              style={{
                width: "400px",
                height: "400px",
              }}
            />
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={incentiveHistory.incentiveHistoryModal}
        onRequestClose={() =>
          setIncentiveHistory({
            ...incentiveHistory,
            incentiveHistoryModal: false,
          })
        }
        contentLabel="Incentive History Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer incentiveHostoryModalContainer">
          <ModalHeadAndClose
            title=""
            onClose={() =>
              setIncentiveHistory({
                ...incentiveHistory,
                incentiveHistoryModal: false,
              })
            }
          />
          <IncentiveHistory rowData={incentiveHistory} />
        </div>
      </Modal>

      {!isAdmin && (
        <div className="singleFlexStartProfileCardContainer">
          <div className="card receptionistProfileCardContainer">
            <div className="img">
              <img
                src={allIncentivesData?.staff?.[0]?.profile || BodyBuilder}
                alt="profile"
              />
            </div>
            <div className="infos">
              <div className="name">
                <h4>{allIncentivesData?.staff?.[0]?.account_type || "N/A"}</h4>
                <h2>{allIncentivesData?.staff?.[0]?.name || "N/A"}</h2>
              </div>
              <p className="tagname">
                Mobile number -
                <span>{allIncentivesData?.staff?.[0]?.mobile || "N/A"}</span>
              </p>
              <p className="tagname">
                email -
                <span style={{ textTransform: "lowercase" }}>
                  {allIncentivesData?.staff?.[0]?.email || "N/A"}
                </span>
              </p>
              <p className="tagname">
                gym name -
                <span>{allIncentivesData?.staff?.[0]?.gym_name || "N/A"}</span>
              </p>
            </div>
          </div>
        </div>
      )}

      {isAdmin ? (
        <div className="grid-k grid-col-5-k gap-4 w-full-k">
          {selectedGyms?.value && (
            <RenewalCard
              onClick={handleCardClick}
              active={selectedFilter?.label === selectedGyms?.label}
            >
              <div className="flex-k items-start-k flex-col-k gap-3 p-1-k flexCenter">
                <span className="px-2">{selectedGyms?.label}</span>
                <div className="grid-k grid-col-2-k border-k w-full-k px-3 p-2 px-3 rounded-3 js-between-k">
                  <div className="flex-k border-right flex-col-k flexCenter">
                    <label
                      className={`${
                        selectedFilter?.label === selectedGyms?.label
                          ? ""
                          : "text-muted"
                      }`}
                    >
                      Earnings
                    </label>
                    <span className="earnings-text">
                      {incentives[selectedGyms?.value]?.total_earning || 0}
                    </span>
                  </div>
                  <div className="flex-k items-center-k flex-col-k flexCenter">
                    <label
                      className={`${
                        selectedFilter?.label === selectedGyms?.label
                          ? ""
                          : "text-muted"
                      }`}
                    >
                      Penalty
                    </label>
                    <span className="penalty-text">
                      {incentives[selectedGyms.value]?.panelty || 0}
                    </span>
                  </div>
                </div>
              </div>
            </RenewalCard>
          )}
        </div>
      ) : (
        <div className="horizontallyScrollCardsContainer">
          <div className="cussss renewlaCustomDraggable">
            <div className="cardsCotaier">
              <div className="cardBox" style={{ cursor: "not-allowed" }}>
                <div className="oneSideCard left">
                  <span className="tagName">Base Salary</span>
                  <p className="totalTag">
                    ₹
                    {parseFloat(
                      allIncentivesData?.staff?.[0]?.base_salary
                    )?.toFixed(2) || 0}
                  </p>
                </div>
                <div className="oneSideCard rigth"></div>
              </div>
              <div className="cardBox">
                <div className="oneSideCard left">
                  <span className="tagName">Rewards</span>
                  <p className="totalTag">
                    ₹
                    {parseFloat(
                      allIncentivesData?.staff?.[0]?.earnings?.totalEarning
                    )?.toFixed(2) || 0}
                  </p>
                </div>
                <div
                  className="oneSideCard rigth"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setIncentiveHistory({
                      ...incentiveHistory,
                      tabName: "rewards",
                      incentiveHistoryModal: true,
                      incentiveHistoryData: allIncentivesData?.staff?.[0],
                    });
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-caret-right"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6 12.796V3.204L11.481 8zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753" />
                  </svg>
                  {/* <MdOutlineArrowForwardIos
                    className="icon"
                    onClick={() => {
                      setIncentiveHistory({
                        ...incentiveHistory,
                        tabName: "rewards",
                        incentiveHistoryModal: true,
                        incentiveHistoryData: allIncentivesData?.staff?.[0],
                      });
                    }}
                  /> */}
                </div>
              </div>
              <div className="cardBox">
                <div className="oneSideCard left">
                  <span className="tagName">Renewals</span>
                  <p className="totalTag">
                    ₹
                    {parseFloat(
                      allIncentivesData?.staff?.[0]?.earnings_renewals
                        ?.totalEarning
                    )?.toFixed(2) || 0}
                  </p>
                </div>
                <div
                  className="oneSideCard rigth"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setIncentiveHistory({
                      ...incentiveHistory,
                      tabName: "renewals",
                      incentiveHistoryModal: true,
                      incentiveHistoryData: allIncentivesData?.staff?.[0],
                    });
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-caret-right"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6 12.796V3.204L11.481 8zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753" />
                  </svg>
                  {/* <MdOutlineArrowForwardIos
                    className="icon"
                    onClick={() => {
                      setIncentiveHistory({
                        ...incentiveHistory,
                        tabName: "renewals",
                        incentiveHistoryModal: true,
                        incentiveHistoryData: allIncentivesData?.staff?.[0],
                      });
                    }}
                  /> */}
                </div>
              </div>
              <div className="cardBox" style={{ cursor: "not-allowed" }}>
                <div className="oneSideCard left">
                  <span className="tagName">Total salary</span>
                  <p className="totalTag">
                    ₹
                    {parseFloat(
                      allIncentivesData?.staff?.[0]?.totalSalary
                    )?.toFixed(2) || 0}
                  </p>
                </div>
                <div className="oneSideCard rigth"></div>
              </div>
            </div>
          </div>
        </div>
      )}

      {!isAdmin ? (
        <>
          {/* <div className="riTabsContainer incentivesTabs">
            <div className="tabsPayoutsContainer dualTab">
              <Tabs id="uncontrolled-renewals-incentives-tab" className="mb-3">
                <Tab eventKey="rewards" title="Rewards">
                  <RewardsIncentiveTable />
                </Tab>
                <Tab eventKey="renewals-renewals" title="Renewals">
                  <RenewalsIncentiveTable />
                </Tab>
              </Tabs>
            </div>
          </div> */}
        </>
      ) : (
        <div className="allPtMembersContainer">
          <div className="tabsSpacebetweenContainer flexBetween">
            <div className="tabsChild span4">
              <div className="headingAndButtonsContainer">
                <h2 className="header">All Trainer / Sales Executive</h2>
              </div>
            </div>
            <div className="tabsChild span2 searchBarContainer">
              <input
                type="search"
                className="input-k px-3"
                placeholder="Search..."
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
              />
              <button
                type="button"
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={onClickSearch}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
              </button>
            </div>
          </div>

          <div
            className="allPtMembersTableContainer rewardsRenewal"
            ref={tableIncRef}
          >
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <PayoutsTable
                columnsValues={allIncentivesTableColumns}
                dataValues={allIncentive.incentivesTableData}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Incentives;
